<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import { ButtonVariant } from "../../../core/schema/ButtonVariant.js";
	import type { WebClient } from "@core/schema/WebClient.js";
	import { getClientDetailPath } from "@core/schema/paths/getClientDetailPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Formatted from "./common/Formatted.svelte";
	import Link from "./common/Link.svelte";
	import Media from "./common/Media.svelte";

	const { client, class: customClass }: { client: WebClient; class?: ClassValue } = $props();
	const { tenant } = getGlobalTemplateProps();
</script>

<div
	class={[
		"bg-white/50 flex flex-col h-full p-3 md:p-6 w-40 md:w-72 min-h-[8.5rem] md:min-h-[13.125rem] rounded-xl md:rounded-3xl backdrop-blur-lg",
		customClass,
	]}
>
	<div class="flex flex-1 min-h-0 items-center justify-center">
		<Media
			draggable={false}
			alt="Logo firmy {client.name}"
			source={client.logo}
			height={80}
			width={192}
			wrapperClass="block h-10 w-full max-w-[7rem] md:h-[4.5rem] md:max-w-48"
			class="h-full w-full object-contain"
			sourcesets={{
				"<2xl": [160, 0],
				">2xl": [160, 0],
			}}
		/>
	</div>

	<div class="flex h-6 md:h-8 shrink-0 items-center justify-center">
		{#if client.hasDetail}
			<Link
				href={getClientDetailPath(tenant, client)}
				variant={ButtonVariant.Text}
				icon="arrow"
				class="flex items-center group/underline gap-4"
			>
				<Formatted text="hover[[Detail klienta]]" />
			</Link>
		{/if}
	</div>
</div>
